import { render, staticRenderFns } from "./orderinfo.vue?vue&type=template&id=0f7d13ca&scoped=true&"
import script from "./orderinfo.vue?vue&type=script&lang=js&"
export * from "./orderinfo.vue?vue&type=script&lang=js&"
import style0 from "./orderinfo.vue?vue&type=style&index=0&id=0f7d13ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d13ca",
  null
  
)

export default component.exports